import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09d5e087"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " (선택) 광고성 정보 수신 동의 안내 ", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "greeting" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 테라사이클의 광고성 정보를 받아 보시기를 원하신다면 아래 내용을 확인하시고 동의해주세요. ")
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<p data-v-09d5e087> 테라사이클코리아(유)/(이하 “회사”)는 “정보통신망 이용촉진 및 정보보호에 관한 법률”, “개인정보보호법” 등 관계 법령에 따라 광고성 정보를 전송하기 위해 수신자의 사전 수신 동의를 받고 있으며, 광고성 정보 수신자의 수신 동의 여부를 정기적으로 확인합니다. 다만 동의하지 않을 경우, 상품/서비스 소개 및 권유, 사은행사, 판촉 행사 등 이용 목적에 따른 혜택에 제한이 있을 수 있습니다. </p><section data-v-09d5e087><h4 data-v-09d5e087>01 목적</h4><ul data-v-09d5e087><li data-v-09d5e087>문자 메시지, 이메일 등을 통한 광고성 정보 전송</li><li data-v-09d5e087>새로운 신규 캠페인 및 이벤트 정보 안내</li><li data-v-09d5e087>혜택, 이벤트, 광고 등 마케팅에 활용</li></ul></section><section data-v-09d5e087><h4 data-v-09d5e087>02 이용 항목</h4><p data-v-09d5e087>휴대폰 번호, 이메일주소</p></section><section data-v-09d5e087><h4 data-v-09d5e087>03 보유 및 이용 기간</h4><p data-v-09d5e087>광고성 정보 수신 동의일로부터 탈퇴 또는 별도 동의 철회 시, 약관 철회 후 2주일까지</p></section><p class=\"notice\" data-v-09d5e087> * 본 동의는 선택 동의로서 거부하실 수 있으며, 거부하시더라도 서비스 이용에는 제한이 없습니다. <br data-v-09d5e087> * 광고성 정보 수신 동의/해제는 언제든지 마이페이지-프로필 수정을 통해 변경하실 수 있습니다. </p>", 5)

import { authStore } from '@/stores';
import { computed, onMounted } from 'vue';
import _ from 'lodash';
import { request, alert } from '@/utils';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const name = computed(() => _.get(authStore.user, 'profile.nick_name') || 'nickname');

onMounted(async () => {
  await authStore.tryFetchData();
  if (authStore.user?.subscribe_tc_information) {
    router.replace({ name: 'mine.memberProfile' });
  }
});

async function handleSubscribe() {
  const { data } = await request.put('/mine', {
    subscribe_tc_information: true
  });
  authStore.user = data;
  await alert({ title: t('Success'), content: t('Operation success'), });
  router.replace({ name: 'mine.memberProfile' });
}

return (_ctx: any,_cache: any) => {
  return (_unref(name))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("article", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(" 안녕하세요, " + _toDisplayString(_unref(name)) + "님! ", 1),
            _hoisted_5,
            _hoisted_6
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", {
          class: "button",
          onClick: handleSubscribe
        }, " 동의합니다 ")
      ]))
    : _createCommentVNode("", true)
}
}

})